import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import React from 'react'

import { editorSx } from './editorStyles'
import type { EditorComponentProps } from './registry'

type Option = { value: string | number; label: string }

export const MultiSelectEditor: React.FC<EditorComponentProps> = (params) => {
	const apiRef = useGridApiContext()
	const options = (params.componentOptions.options ?? []) as Option[]
	const placeholder = (params.componentOptions.prompt as string | null | undefined) ?? params.colDef.headerName ?? ''
	const value = (params.value ?? []) as (string | number)[]
	return (
		<Select
			multiple
			displayEmpty
			value={value}
			onChange={(e) => apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: e.target.value })}
			size="small"
			fullWidth
			autoFocus
			sx={editorSx}
			renderValue={(selected) => {
				const picked = (selected as (string | number)[]) ?? []
				if (picked.length === 0) {
					return <em style={{ color: 'rgba(0, 0, 0, 0.4)' }}>{placeholder}</em>
				}
				return options
					.filter((o) => picked.includes(o.value))
					.map((o) => o.label)
					.join(', ')
			}}
		>
			{options.map((opt) => (
				<MenuItem key={opt.value} value={opt.value}>
					<Checkbox checked={value.includes(opt.value)} />
					<ListItemText primary={opt.label} />
				</MenuItem>
			))}
		</Select>
	)
}
